// Daily analysis quota for the Coffre — stored in localStorage only (RGPD-safe).
const KEY = "aia_analyze_quota";
export const DAILY_LIMIT = 4;

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { date: todayKey(), count: 0 };
    const parsed = JSON.parse(raw);
    if (parsed.date !== todayKey()) return { date: todayKey(), count: 0 };
    return parsed;
  } catch {
    return { date: todayKey(), count: 0 };
  }
}

function write(state) {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function getUsage() {
  return read();
}

export function getRemaining() {
  const { count } = read();
  return Math.max(0, DAILY_LIMIT - count);
}

export function canAnalyze() {
  return getRemaining() > 0;
}

export function consume() {
  const s = read();
  s.count += 1;
  write(s);
  return s.count;
}
